import 'whatwg-fetch';
import 'promise-polyfill/src/polyfill';
import 'es6-shim';
import App from './App.svelte';

const app = new App({
	target: document.querySelector('#svelte-container'),
	props: {
		ready: false
	}
});

window.initMap = function ready() {
	app.$set({ ready: true });
}

export default app;
